import { useSelector } from 'app-redux'
import { useMemo } from 'react'
import { SimpleGroupingTask } from './simple-grouping-redux'

/**
 * The task of the group work on screen, as `SIMPLE_GROUPING_STATE_CHANGED`
 * last reported it.
 *
 * The event is the source, not the current script step: the backend's
 * `SimpleGrouping` holds the task the room is working on whichever way group
 * work was started, while the script step says nothing once the trainer has
 * moved the agenda on or started group work from the menu.
 *
 * `undefined` when there is no task at all - group work that was never given
 * one. The screens fall back to their heading rather than assume a task.
 */
export const useSimpleGroupingTask = (): SimpleGroupingTask | undefined => {
	const name = useSelector(state => state.simpleGrouping.name)
	const description = useSelector(state => state.simpleGrouping.description)
	return useMemo(
		() => (name || description ? { name, description } : undefined),
		[name, description]
	)
}
